import { render } from "./HomepageLive.vue?vue&type=template&id=a1a3b478&scoped=true"
import script from "./HomepageLive.vue?vue&type=script&lang=js"
export * from "./HomepageLive.vue?vue&type=script&lang=js"

import "./HomepageLive.vue?vue&type=style&index=0&id=a1a3b478&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1a3b478"]])

export default __exports__